import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5742a030&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5742a030')) {
      api.createRecord('5742a030', component.options)
    } else {
      api.reload('5742a030', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5742a030&", function () {
      api.rerender('5742a030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TimeZoneCheck/index.vue"
export default component.exports